import { gatewayInstance } from "../server/gateway";
import { SubInfo, SubType } from "@/types/sub";
import { to } from "@/utils/promiseUtils";
/**
 * 组织号关注列表
 * @param body
 */
export async function followSubscriptionList(body: { type: SubType }) {
  return to<{ follows: SubInfo[]; recommends: SubInfo[] }>(
    gatewayInstance.request({
      api: "sub.followSubscriptionList",
      method: "POST",
      body
    })
  );
}

/**
 * 关注取消关注
 */
export async function followSubscription(body: {
  /** 组织号id */
  subId: string;
  /** 0=取消关注,1=关注 */
  followed: number;
}) {
  return to(
    gatewayInstance.request({
      api: "sub.followSubscription",
      method: "POST",
      body
    })
  );
}

/**
 * 查询当前用户有运营权限的组织号列表
 */
export async function operatorAuthSubIds(body: {
  /** 用户id */
  userId: string;
  /** 租户id */
  teamId: string;
  /** 应用id */
  appId: string;
  // depts: {
  //   /** 部门Id */
  //   deptId: string;
  //   /** 部门名称 */
  //   deptName: string;
  //   /** 部门fullPath */
  //   fullPath: string;
  // }[];
}) {
  return to<{ subIds: string[] }>(
    gatewayInstance.request({
      api: "sub.operatorAuthSubIds",
      method: "POST",
      body
    })
  );
}

/**
 * 获取组织号详情
 */
export async function getSubscription(body: {
  /** 组织号id */
  subId: string;
}) {
  return await to(
    gatewayInstance.request({
      api: "sub.getSubscription",
      method: "POST",
      body
    })
  );
}
